module.exports = __webpack_public_path__ + "img/icon-phone.a215d1f1.png";